import { RtRequest } from "src/components/ReactiveTable/RtRequest";
import { RtResponse } from "src/components/ReactiveTable/RtResponse";
import { AbstractFilters } from "src/components/ReactiveTable/RtTypes";
import z from "zod";

import { dataParser } from "./dataParser";
import { rest } from "./rest";

export const mdmLoader = <
  RowScheme extends z.ZodObject,
  Filters extends AbstractFilters,
>(
  scheme: RowScheme,
  url: string,
) => {
  type TRow = z.infer<RowScheme>;
  return async (request: RtRequest<Filters>): Promise<RtResponse<TRow>> => {
    const params = {
      ...request.filters,
      page: request.page,
      size: request.pageSize,
    };
    const zResult = z.object({
      content: scheme.array(),
      pagination: z.object({
        totalElements: z.number(),
      }),
    });
    const resp = await rest.get(url, { params });
    const { content, pagination } = dataParser(
      () => zResult.parse(resp.data),
      url,
    );
    return {
      rows: content,
      totalRows: pagination.totalElements,
    };
  };
};
